import { apiSlice } from './apiSlice'

export interface Case {
  id: string
  title: string
  parties_requests?: string  // Yêu cầu các bên
  description?: string  // Mô tả chi tiết (quản lý qua upload tài liệu)
  // Thông tin cơ bản cuộc thi
  case_number?: string
  case_type?: string
  court?: string
  // Các bên liên quan
  plaintiff?: string
  defendant?: string
  // Thông tin thời gian
  incident_date?: string
  filing_date?: string
  // Thông tin khác
  dispute_value?: string
  legal_area?: string
  summary?: string
  // Trạng thái và phân bổ
  status: string
  current_round_id?: string  // Round ID hiện tại đang diễn ra
  assigned_team_ids?: string[]  // List of team IDs (có thể phân bổ cho nhiều đội)
  assigned_by?: string
  assigned_at?: string
  deadline?: string
  created_at?: string
  updated_at?: string
}

export interface CaseCreate {
  title: string
  parties_requests?: string
  description?: string
  case_number?: string
  case_type?: string
  court?: string
  plaintiff?: string
  defendant?: string
  incident_date?: string
  filing_date?: string
  dispute_value?: string
  legal_area?: string
  summary?: string
  deadline?: string
}

export interface CaseAssign {
  team_ids: string[]  // List of team IDs (có thể chọn nhiều đội)
  deadline?: string
  notes?: string
}

export const casesApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCases: builder.query<Case[], void>({
      query: () => '/cases',
      providesTags: ['Case'],
    }),
    getCase: builder.query<Case, string>({
      query: (id) => `/cases/${id}`,
      providesTags: (result, error, id) => [{ type: 'Case', id }],
    }),
    createCase: builder.mutation<Case, CaseCreate>({
      query: (body) => ({
        url: '/cases',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Case'],
    }),
    updateCase: builder.mutation<Case, { id: string } & Partial<CaseCreate>>({
      query: ({ id, ...data }) => ({
        url: `/cases/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [{ type: 'Case', id }],
    }),
    assignCase: builder.mutation<Case, { caseId: string; assignment: CaseAssign }>({
      query: ({ caseId, assignment }) => ({
        url: `/cases/${caseId}/assign`,
        method: 'POST',
        body: assignment,
      }),
      invalidatesTags: (result, error, { caseId }) => [{ type: 'Case', id: caseId }, 'Team'],
    }),
    moveToNextRound: builder.mutation<Case, string>({
      query: (caseId) => ({
        url: `/cases/${caseId}/move-to-next-round`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, caseId) => [
        { type: 'Case', id: caseId },
        { type: 'Round' },
      ],
    }),
    moveToRound: builder.mutation<{ message: string; current_round_id: string }, { caseId: string; roundId: string }>({
      query: ({ caseId, roundId }) => ({
        url: `/cases/${caseId}/move-to-round/${roundId}`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, { caseId }) => [
        { type: 'Case', id: caseId },
        { type: 'Round' },
      ],
    }),
    deleteCase: builder.mutation<{ message: string }, string>({
      query: (id) => ({
        url: `/cases/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Case', 'Round'],
    }),
  }),
})

export const {
  useGetCasesQuery,
  useGetCaseQuery,
  useCreateCaseMutation,
  useUpdateCaseMutation,
  useAssignCaseMutation,
  useMoveToNextRoundMutation,
  useMoveToRoundMutation,
  useDeleteCaseMutation,
} = casesApi
